export default __webpack_public_path__ + "static/Food4-96356afe0fa8f9dacf88da46ea5761ca.jpg";